import axios from 'axios';
import { xhrRequestConfig, getDotDigitalContactEndpointUrl, getDotDigitalRepairEndpointUrl, getDotDigitalReplaceEndpointUrl } from '../utils/api.js';

const DOT_DIGITAL_CONTACT_ENDPOINT = getDotDigitalContactEndpointUrl();
const DOT_DIGITAL_REPAIR_ENDPOINT = getDotDigitalRepairEndpointUrl();
const DOT_DIGITAL_REPLACE_ENDPOINT = getDotDigitalReplaceEndpointUrl();

export default function dotDigitalFormController() {
    return {
        mounted() {
            window.dotDigitalContactSubmit = ( val => this._submitDotDigitalForm(val, DOT_DIGITAL_CONTACT_ENDPOINT));
            window.dotDigitalGlassesRepair = ( val => this._submitDotDigitalUploadForm(val, DOT_DIGITAL_REPAIR_ENDPOINT));
            window.dotDigitalLensReplacement = ( val => this._submitDotDigitalReplaceForm(val, DOT_DIGITAL_REPLACE_ENDPOINT));
        },

        methods: {
            _submitDotDigitalForm(data, endpointUrl) {
                return axios.post(endpointUrl, data, xhrRequestConfig).then(async (response) => {
                    return response.data;
                }).catch((error) => {
                    console.log(error);
                    return error;
                })
            },
            _submitDotDigitalUploadForm(data, endpointUrl) {
                let requestConfig = {
                        headers: {
                            ...xhrRequestConfig,
                            "Content-Type": "multipart/form-data"
                        }
                    },
                    formData = new FormData();

                // Build a new formdata object
                for (let key in data) {
                    formData.append(key, data[key]);
                };

                return axios.post(endpointUrl, formData, requestConfig).then(async (response) => {
                    return response.data;
                }).catch((error) => {
                    console.log(error);
                    return error;
                })
            },
            _submitDotDigitalReplaceForm(data, endpointUrl) {
                let requestConfig = {
                        headers: {
                            ...xhrRequestConfig,
                            "Content-Type": "multipart/form-data"
                        }
                    },
                    formData = new FormData();

                // Build a new formdata object
                for (let key in data) {
                    formData.append(key, data[key]);
                };

                return axios.post(endpointUrl, formData, requestConfig).then(async (response) => {
                    return response.data;
                }).catch((error) => {
                    console.log(error);
                    return error;
                })
            }
        }
    }
};